// Clinic Configuration for Dentist In Concord
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Dentist in Austin",
  clinicId: "dentistinaustin",
  clinicUrl: "https://dentistinaustintx.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=dentistinaustin&agentId=79427189-7525-4072-8240-07a5f145190a",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/dentistinaustin/voice",

  // Contact Information
  phoneNumber: "5124304472",
  phoneNumberRaw: "+15124304472", // For tel: and sms: links
  email: "dentalcare@dentistinaustintx.com",

  // Location
  address: "2110 W Slaughter Ln Ste 190, Austin, TX 78748, United States",
  addressShort: "2110 W Slaughter Ln Ste 190, Austin, TX 78748, USA",
  city: "Austin",
  hcity: "Austin",
  state: "Texas",
  stateShortForm: "TX",
  PostalCode: "78748",

  // Map Links
  mapUrl: "https://maps.app.goo.gl/zNd6h5pCWYV1wxs57",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d104912.66240333545!2d-97.823794!3d30.174754!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x865b4cf440b822df%3A0x4432f69e6b87f65!2sDentist%20in%20Austin!5e1!3m2!1sen!2sin!4v1756790337341!5m2!1sen!2sin',
  iframeTitle: "Dentist In Austin",

  //membership
  membership: "https://member.kleer.com/?slug=RE6D",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/TodaysDentalPartners-DentistInAustin",

  // Cherry
  cherryUrl: "https://dentistinaustintx.com/patient-portal",

  // Analytics
  clarityProjectId: "q5ntnauzgw",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/dentistinaustin",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/dentistinaustin",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/dentistinaustin",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://dentistinaustintx.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/dentistinaustintanglewood",
    instagram: "https://www.instagram.com/stories/dentistinaustin/",
    twitter: "https://x.com/dent_inaustin",
    linkedin: "https://www.linkedin.com/company/107863979/admin/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3BZHzZHS4UQLaEyel%2BGoze8g%3D%3D",
    youtube: "https://www.youtube.com/@DentistinAustin",
  },

  // Open Dental Configuration
  defaultProvNum: 1,
  defaultOpNum: 11,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: 'New patient emergency/other',
      label: 'New patient emergency/other',
      duration: 30,
      opNum: 9,
      AppointmentTypeNum: 6
    },
    {
      value: 'Existing patient emergency/other',
      label: 'Existing patient emergency/other',
      duration: 30,
      opNum: 11,
      AppointmentTypeNum: 8
    },
    {
      value: 'Existing patient current treatment Plan',
      label: 'Existing patient current treatment Plan',
      duration: 30,
      opNum: 11,
      AppointmentTypeNum: 3
    }
  ],

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:${this.phoneNumberRaw}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;

